import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import { EXPORT_TERMS_AND_CONDITIONS_LINK } from '../../ExportModalConstants';

import './ExportModalContentDisclaimer.scss';

function ExportModalContentDisclaimer({ data }) {
  const { exportAttemptsLimit, exportAttemptsCurrentlyUsed } = data;

  const renderLimitWarning = () => {
    if (!exportAttemptsLimit || !exportAttemptsCurrentlyUsed) {
      return null;
    }

    if (exportAttemptsLimit - exportAttemptsCurrentlyUsed > 1) {
      return <span>{`This is export attempt ${exportAttemptsCurrentlyUsed} out of ${exportAttemptsLimit} for today.`}</span>;
    }

    if (exportAttemptsLimit - exportAttemptsCurrentlyUsed === 1) {
      return (
        <span>{`This is export attempt ${exportAttemptsCurrentlyUsed}. You are approaching your export limit of ${exportAttemptsLimit} for today.`}</span>
      );
    }

    if (exportAttemptsLimit === exportAttemptsCurrentlyUsed) {
      return <span>{`This is export attempt ${exportAttemptsCurrentlyUsed}. This is final export for today.`}</span>;
    }

    return null;
  };

  const onLinkClick = () => {
    window.open(EXPORT_TERMS_AND_CONDITIONS_LINK, '_blank');
  };

  return (
    <div className="exportModal__disclaimer disclaimer">
      <div className="exportModal__content_row">
        <div className="disclaimer__icon">i</div>
        <div className="disclaimer__content">
          {renderLimitWarning()}
          <span>
            <b>Disclaimer:</b> please refer to our
            <Button
              type="button"
              onClick={onLinkClick}
              buttonConfig={{
                label: 'Terms and Conditions',
                type: 'link',
                size: 'sm',
                e2eName: 'export-modal-content-link',
              }}
            />
            before downloading data.
          </span>
        </div>
      </div>
    </div>
  );
}

ExportModalContentDisclaimer.propTypes = {
  data: PropTypes.object,
};

export default ExportModalContentDisclaimer;
